import {
  ShowsForUserActionManager,
  MediaFileActionManager,
  EpisodesByShowActionManager,
} from "../../../action_managers/shows";
import { USER_IMPORT_JOB, USER_ATTRIBUTE } from "../../../actions/user";
import ShowListPage from "./show_list_page";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import DefaultActionManager from "../../../action_managers/default_action_manager";
import { showModal } from "../../../actions/modal";
import { WELCOME_MODAL } from "../../modals/modal_root";
import { HAS_SEEN_WELCOME_MODAL } from "../../../constants/user_attributes";
import { withPageTitle } from "../../lib/WithPageTitle";
import { getShowCampaigns } from "../../../actions/campaigns";

function mapStateToProps(state) {
  var props = {
    isLoading: state.shows.isLoading,
    shows: state.shows.shows,
    user: state.user.user,
    currentRole: state.user.currentRole,
    importJobs: state.user.importJobs,
    showMediaFiles: state.mediaFiles,
    episodesByShow: state.episodesByShow,
    campaignItems: state.campaignItems,
  };
  return props;
}

const mapDispatchToProps = {
  getShowCampaigns,
  fetchShowsForUser: user => new ShowsForUserActionManager({ user }).run(),
  fetchMediaFile: (mediaFileUUID, authToken) =>
    new MediaFileActionManager({ mediaFileUUID, authToken }).run(),
  fetchEpisodesForShow: (showUUID, user) =>
    new EpisodesByShowActionManager({ showUUID, user }).run(),
  fetchJobsForUser: user =>
    new DefaultActionManager({
      auth: true,
      route: `users/${user.uuid}/import-jobs`,
      actionName: USER_IMPORT_JOB,
    }).run(),
  showWelcomeModal: (isInvitedUser, isSponsoredUser) =>
    showModal(WELCOME_MODAL, { isInvitedUser, isSponsoredUser }),
  markWelcomeModalSeen: () =>
    new DefaultActionManager({
      auth: true,
      route: `users/me/set-attribute`,
      actionName: USER_ATTRIBUTE,
      method: "POST",
      body: {
        key: HAS_SEEN_WELCOME_MODAL,
        value: "true",
      },
    }).run(),
};

const ShowListPageWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(ShowListPage));

export default withPageTitle(ShowListPageWrapper, "Podcasts");
